import React from 'react';
import { LUCK_COLOR, HARM_COLOR, HARM_STATE_COLOR, MEN_STATE_COLOR } from '../qimen/colors.js';

export default function Legend({ shenMode }) {
  return (
    <div className="legend">
      <div className="legend-block">
        <h4>干支颜色（天盘干／地支）</h4>
        <div className="legend-items">
          <span className="chip" style={{ color: HARM_STATE_COLOR.none, borderColor: '#ccc' }}>黑 = 无四害</span>
          <span className="chip" style={{ color: HARM_STATE_COLOR.xing, borderColor: HARM_STATE_COLOR.xing }}>红 = 击刑</span>
          <span className="chip" style={{ color: '#666', borderColor: HARM_STATE_COLOR.mu }}>灰 = 入墓</span>
          <span className="chip" style={{ color: HARM_STATE_COLOR.xingmu, borderColor: HARM_STATE_COLOR.xingmu }}>紫 = 刑＋墓</span>
        </div>
      </div>

      <div className="legend-block">
        <h4>八门颜色</h4>
        <div className="legend-items">
          <span className="chip" style={{ color: MEN_STATE_COLOR.none, borderColor: '#ccc' }}>黑 = 正常</span>
          <span className="chip" style={{ color: MEN_STATE_COLOR.po, borderColor: MEN_STATE_COLOR.po }}>红 = 门迫（门克宫）</span>
        </div>
      </div>

      <div className="legend-block">
        <h4>神·星吉凶</h4>
        <div className="legend-items">
          {['吉', '平', '凶'].map(k => (
            <span key={k} className="chip" style={{ color: LUCK_COLOR[k], borderColor: LUCK_COLOR[k] }}>
              {k}
            </span>
          ))}
        </div>
      </div>

      <div className="legend-block">
        <h4>空亡与标记</h4>
        <div className="legend-items">
          <span className="kong-demo" title="时空亡落宫" />
          <span className="legend-tip">○ 小圆 = 时空亡落宫（日空不显示）</span>
          <span className="chip chip-fu">符 = 值符宫</span>
          <span className="chip chip-shi">使 = 值使宫</span>
          <span className="chip chip-ma">马 = 驿马</span>
        </div>
      </div>

      <p className="legend-note">
        盘面结构：每宫<b>上＝神盘</b>、<b>左＝九星（天盘）</b>、<b>中＝八门（人盘，单字）</b>、
        <b>右＝天盘干（上行）与地支（下行，等大）</b>；天禽随天芮寄宫时，坤宫天地两行各显两字
        （如 丙壬）。点击任意宫位可查看神／星／门／干释义、天地盘生克、空亡细节与四害详解。
        八神布法：{shenMode === 'yin' ? '阴盘 · 不分阴阳遁，自值符宫一律顺时针排布'
          : shenMode === 'classic' ? '传统阳盘 · 阳遁顺时针、阴遁逆时针'
            : '九神盘 · 阳顺阴逆，太常居中五（市售阴盘 APK 法度）'}。
      </p>
    </div>
  );
}
